<template>
    <span class="badge rounded-pill bg-danger defeated-badge">Defeated</span>
</template>

<script>
export default {
    name: "proposition-defeated-badge",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>
.defeated-badge{
     /*badge-color: #396f3a;*/
}
</style>
